import React, { useState } from 'react';
import { useCurrentProjectIdContext, useTranslationContext } from "./project-builder-main.jsx";
import { useUpdateProduct } from '../../../components/project-builder-custom-hooks';
import Modal from 'react-modal';


export default function NotesModal({ readOnly, product }) {

    Modal.setAppElement('#main');

    const { currentProjectId } = useCurrentProjectIdContext();
    const {translations} = useTranslationContext();

    const { mutate: updateProduct, isLoading } = useUpdateProduct(currentProjectId);

    const [isOpen, setIsOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const [notes, setNotes] = useState(product.Notes);

    const openModal = () => {
        setIsOpen(true);
    }

    const closeModal = () => {
        setIsOpen(false);
    }

    const handleFormSubmit = (event, payload) => {
        setIsEditing(false);
        event.preventDefault();
        updateProduct(payload);
    }

    const handleEdit = () => {
        setIsEditing(true);
    }

    const handleChange = (e) => {
        setNotes(e.target.value);
    }

    return (
        <>
            {(!readOnly || (readOnly && product.notes?.length))
                ? <button class="link-btn underline" type="button" onClick={openModal}>Notes {product.notes?.length ? "(1)" : ""}</button>
                : <div className="no-note">{translations.Notes}</div>
            }
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                className="project-builder project-builder-modal project-builder-modal--small"
            >
                <button className="project-builder-modal-close" onClick={closeModal}>
                    <svg id="header-ask-close-svg" className="icon icon-close"><use xlinkHref="#icon-close"></use></svg>
                </button>
                <div className='modal-title'>{translations.Notes}</div>
                <p>{translations.AddYourNotes}</p>

                {(product.notes && !isEditing)
                    ? (
                        <div className="product-notes-list-item">
                            <div className="product-notes-media">
                                <img src={product.imageUrl} alt={product.title} />
                            </div>
                            <div className="product-notes-content">
                                <div className="product-notes-title"><strong>{product.sku}</strong> {product.title.length > 29 ? product.title.slice(0,29) + "..." : product.title}</div>
                                <div>{ notes }</div>
                            </div>
                            {readOnly ? null
                                : <div className="product-notes-actions ml-auto">
                                    <button class="btn--delete" type="button" disabled={isLoading} onClick={() => updateProduct({ id: product.id, notes: null })}>
                                        <span className="icon icon--trash"></span>
                                    </button>

                                    <button class="link-btn mr-0 ml-1" type="button" disabled={isLoading} onClick={handleEdit}>
                                        <span className="icon icon--edit"></span>
                                    </button>
                                </div>
                            }
                        </div>
                    )
                    : (
                        <form className="project-builder-form" action="#" method="post" onSubmit={() => handleFormSubmit(event, { id: product.id, notes: notes })}>

                            <div className="form-group form-group--relative">
                                <label className="sr-only" htmlFor="notes">{translations.Notes}</label>
                                <textarea className="form-control" id="notes" name="notes" rows="5" maxlength="200" placeholder={translations.EnterYourComments} value={notes} onChange={handleChange}></textarea>
                                <div className="character-count">{notes?.length ? notes.length : "0"} / 200</div>
                            </div>
                            <div className="form-actions">
                                <button className='btn' type='submit' disabled={isLoading} >{translations.Submit}</button>
                            </div>
                        </form>
                    )
                }
            </Modal>
        </>
    );
}